import React, { useState } from "react";
import { format, parseISO } from "date-fns";
import { it } from "date-fns/locale";
import { DateRangeField, todayRome } from "@/components/DateField";
import { useAuth } from "@/context/AuthContext";
import { CalendarDays, Euro, MapPin, X, SlidersHorizontal } from "lucide-react";
import { ComuneSearch } from "@/components/ComuneSearch";

const inputCls = "w-full border border-slate-300 rounded-full px-4 py-2 text-sm focus:outline-none focus:border-gold";

export function ProviderFilters({ onApply, initialPlace = null, initialDate = null, initialDateTo = null }) {
  const { user } = useAuth();
  const canSeePrices = user && ["public_entity", "business", "admin"].includes(user.role);
  const [date, setDate] = useState(initialDate ? { from: initialDate, to: initialDateTo || initialDate } : null);
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [place, setPlace] = useState(initialPlace);

  const apply = (over = {}) => {
    const s = { date, minPrice, maxPrice, place, ...over };
    const p = {};
    if (s.date?.from) { p.date = s.date.from; if (s.date.to && s.date.to !== s.date.from) p.dateTo = s.date.to; }
    if (canSeePrices && s.minPrice !== "") p.minPrice = s.minPrice;
    if (canSeePrices && s.maxPrice !== "") p.maxPrice = s.maxPrice;
    if (s.place) { p.lat = s.place.lat; p.lng = s.place.lng; }
    onApply(p, s.place);
  };
  const reset = () => { setDate(null); setMinPrice(""); setMaxPrice(""); setPlace(null); onApply({}, null); };

  return (
    <div className="card-premium p-4 mb-8 grid gap-3 md:grid-cols-[auto_1fr_1fr_1fr_auto_auto] items-end" data-testid="provider-filters">
      <div className="hidden md:flex items-center gap-2 text-gold pb-2"><SlidersHorizontal className="w-4 h-4" /><span className="overline">Filtri</span></div>
      <div>
        <label className="overline text-slate-500 mb-1 flex items-center gap-1"><CalendarDays className="w-3 h-3" />Date libere</label>
        <DateRangeField testId="filter-date" value={date} min={todayRome()} onChange={setDate} onDone={(v) => apply({ date: v })} className={`${inputCls} w-full`}/>
      </div>
      <div>
        <label className="overline text-slate-500 mb-1 flex items-center gap-1"><Euro className="w-3 h-3" />Compenso base (€)</label>
        {canSeePrices ? (
          <div className="flex gap-2">
            <input data-testid="filter-min-price" type="number" min="0" placeholder="da" value={minPrice} onChange={(e) => setMinPrice(e.target.value)} className={inputCls} />
            <input data-testid="filter-max-price" type="number" min="0" placeholder="a" value={maxPrice} onChange={(e) => setMaxPrice(e.target.value)} className={inputCls} />
          </div>
        ) : <div className="text-xs text-slate-400 py-2.5" data-testid="filter-price-locked">Riservato a Enti e Organizzatori</div>}
      </div>
      <div>
        <label className="overline text-slate-500 mb-1 flex items-center gap-1"><MapPin className="w-3 h-3" />Comune o provincia</label>
        <ComuneSearch value={place} inputCls={inputCls} onSelect={(c) => { setPlace(c); apply({ place: c }); }} />
      </div>
      <button type="button" data-testid="filter-apply" onClick={() => apply()} className="btn-pill-gold text-sm py-2 justify-center">Applica</button>
      <button type="button" data-testid="filter-reset" onClick={reset} className="btn-pill-outline text-sm py-2 justify-center"><X className="w-4 h-4" />Azzera</button>
    </div>
  );
}

export const prettyDate = (d) => { const p = d ? parseISO(d) : null; return p && !isNaN(p) ? format(p, "EEE d MMM", { locale: it }) : "-"; };
